import { cleanFullAddress, PropertyAddress } from '@urbanx/agx-ui-components';
import { AuthContext } from '@urbanx/agx.auth.client';
import { AgxColumn, AgxRow, AgxTaskCard, IconTaskType } from '@urbanx/agx.ui-components2';
import { MenuTitles } from 'constants/menu';
import { useSelectedAgency, useSelectedCampaign } from 'hooks';
import { ContentLayout, PageLayout } from 'layout';
import { useContext } from 'react';
import mockData from './mockData.json';
import { splitPascalCase } from 'utils/stringUtils';

const CampaignOverview = () => {
  const { userAccount } = useContext(AuthContext);
  const { agency } = useSelectedAgency();
  const { campaign } = useSelectedCampaign();

  const firstIncompleteTask = Object.values(mockData.tasks)
    .sort((a, b) => a.order - b.order) // ensure correct order
    .find((task) => task.isCompleted === false);

  const steps = Object.values(firstIncompleteTask?.steps ?? []);
  const totalSteps = steps.length || 1;
  const completedSteps = steps.filter((step) => step.isCompleted).length || 1;
  const percentage = (completedSteps / totalSteps) * 100;

  // find first incomplete step
  const firstIncompleteStep = steps.find((step) => !step.isCompleted);

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={agency?.name || ''}
      currentPageTitle={`Campaigns / ${cleanFullAddress(campaign?.address as PropertyAddress)}`}
      isCampaignsSection={true}
    >
      <ContentLayout
        hasSecondaryMenu={true}
        secondaryActiveMenu={MenuTitles.CAMPAIGN_OVERVIEW}
        isCampaigns={true}
      >
        <AgxRow fill>
          <AgxColumn fill>
            <AgxTaskCard
              dueDate={firstIncompleteStep?.completeStepBy}
              iconType={firstIncompleteTask?.taskType as IconTaskType}
              id={'taskOverview'}
              title={splitPascalCase(firstIncompleteTask?.taskType ?? '')}
              progress={percentage}
              actionText={'Comple task'}
              onActionClick={function (): void {
                throw new Error('Function not implemented.');
              }}
              cardColor={'green'}
            />
          </AgxColumn>
        </AgxRow>
      </ContentLayout>
    </PageLayout>
  );
};

export default CampaignOverview;
